//站点卡片
const stationCardEn = {
  staCardLang: {
    站点卡片: 'Station Card',
    创建电站: 'Create a power station',
    全部: 'All',
    在线: 'Online',
    离线: 'Offline',
    请选择地区: 'Please select a region',
    查询: 'Query',
    重置: 'Reset',
    搜索电站名称地址: 'Enter the power station name/address',
    以下为: 'Fields searched:',
    的站点: '',
    数量: 'Number',
    进入电站: 'Enter',
    暂无站点图片: 'No site pictures',
    装机容量: 'Installed capacity',
    装机功率: 'Installed power',
    编辑电站: 'Edit',
    查看详情: 'Detail',
    投运时间: 'Operation time',
    电站地址: 'Address',
    查看电站: 'View power station',
    基础信息: 'Basic information',
    更多信息: 'More information',
    电站图片: 'Picture of the power station',
    电站名称: 'Name of power station',
    电站联系电话: 'Power station contact number',
    安装图片: 'Equipment installation pictures',
    并网点信息: 'Consolidation point information',
    有光伏: 'Photovoltaic',
    无光伏: 'No photovoltaics',
    有并网点: 'Parallel branch',
    无并网点: 'No branch',
    其它: 'Others',
    变压器信息: 'Transformer information',
    站点变压器容量: 'Station transformer capacity',
    安装人: 'Installer',
    安装人联系号码: 'Installer Contact Number',
    关闭: 'Close',
    中国: 'China',
    收起: 'Retract',
    打开: 'Open'
  }
}
export default stationCardEn
